import { default as index2YRQU71buZMeta } from "/vercel/path0/app/pages/amalo-grid/index.vue?macro=true";
import { default as indexdGnQbFGcyeMeta } from "/vercel/path0/app/pages/amalo-grid/servicebesog/index.vue?macro=true";
import { default as bliv_45en_45del_45af_45amalo7d59Nbs69wMeta } from "/vercel/path0/app/pages/bliv-en-del-af-amalo.vue?macro=true";
import { default as boligforeningerCUCEiNj089Meta } from "/vercel/path0/app/pages/boligforeninger.vue?macro=true";
import { default as indexVIEXBGmPFGMeta } from "/vercel/path0/app/pages/elvandvarmer/index.vue?macro=true";
import { default as er_45du_45amalos_45nye_45kunderaadgiverUtnXZK1PqdMeta } from "/vercel/path0/app/pages/er-du-amalos-nye-kunderaadgiver.vue?macro=true";
import { default as erhvervED53us6KkhMeta } from "/vercel/path0/app/pages/erhverv.vue?macro=true";
import { default as faa_45et_45gratis_45tilbud_45indenfor_4524_45timerYFWEeakcG8Meta } from "/vercel/path0/app/pages/faa-et-gratis-tilbud-indenfor-24-timer.vue?macro=true";
import { default as garanti_45servicevDIqQLFMJlMeta } from "/vercel/path0/app/pages/garanti-service.vue?macro=true";
import { default as handelsbetingelsertQkbHVwAGNMeta } from "/vercel/path0/app/pages/handelsbetingelser.vue?macro=true";
import { default as hvad_45er_45prisen_45luft_45til_45vand_45varmepumpeNRfcE1p22IMeta } from "/vercel/path0/app/pages/hvad-er-prisen-luft-til-vand-varmepumpe.vue?macro=true";
import { default as hvad_45er_45prisen_45solcellerQ65Gj3sUKYMeta } from "/vercel/path0/app/pages/hvad-er-prisen-solceller.vue?macro=true";
import { default as indexiGEjlfgJ29Meta } from "/vercel/path0/app/pages/index.vue?macro=true";
import { default as kan_45din_45varmepumpe_45kole_45boligen_45nedDkW71t55U5Meta } from "/vercel/path0/app/pages/kan-din-varmepumpe-kole-boligen-ned.vue?macro=true";
import { default as kombinere_45varmepumpe_45solcellerGbz9Nx5fP8Meta } from "/vercel/path0/app/pages/kombinere-varmepumpe-solceller.vue?macro=true";
import { default as kondens_45fra_45varmepumpenQVuNtllBg8Meta } from "/vercel/path0/app/pages/kondens-fra-varmepumpen.vue?macro=true";
import { default as luft_45til_45vand_45varmepumpe_45pris_45montering84DppJaeJ8Meta } from "/vercel/path0/app/pages/luft-til-vand-varmepumpe-pris-montering.vue?macro=true";
import { default as index6FMiXViYdMMeta } from "/vercel/path0/app/pages/luft-til-vand-varmepumpe/index.vue?macro=true";
import { default as panasonic_45varmepumpeUB4jKhxLCtMeta } from "/vercel/path0/app/pages/luft-til-vand-varmepumpe/panasonic-varmepumpe.vue?macro=true";
import { default as minimer_45stoej_45fra_45varmepumpenFVSZCHHDQwMeta } from "/vercel/path0/app/pages/minimer-stoej-fra-varmepumpen.vue?macro=true";
import { default as _91slug_93Ka4Slt87YqMeta } from "/vercel/path0/app/pages/news/[slug].vue?macro=true";
import { default as indexwQRAnyuwSMMeta } from "/vercel/path0/app/pages/news/index.vue?macro=true";
import { default as _91page_939QVJQnvmGhMeta } from "/vercel/path0/app/pages/news/page/[page].vue?macro=true";
import { default as om_45amalouPntpxJvlWMeta } from "/vercel/path0/app/pages/om-amalo.vue?macro=true";
import { default as _91address_936M0yorMKDnMeta } from "/vercel/path0/app/pages/overslag-solceller/[address].vue?macro=true";
import { default as _91address_93NHIVIswG80Meta } from "/vercel/path0/app/pages/overslag/[address].vue?macro=true";
import { default as partnerCzkEWrua8vMeta } from "/vercel/path0/app/pages/partner.vue?macro=true";
import { default as amalo_45logbuy_45solcellernxTI7oG1RHMeta } from "/vercel/path0/app/pages/partnerskab/amalo-logbuy-solceller.vue?macro=true";
import { default as amalo_45logbuypGcLJ9sAAEMeta } from "/vercel/path0/app/pages/partnerskab/amalo-logbuy.vue?macro=true";
import { default as placering_45af_45varmepumpeudppQfsDr6Meta } from "/vercel/path0/app/pages/placering-af-varmepumpe.vue?macro=true";
import { default as privacy_45policyBCFdvKjRduMeta } from "/vercel/path0/app/pages/privacy-policy.vue?macro=true";
import { default as problemer_45med_45varmepumpeRy3CBk2yrGMeta } from "/vercel/path0/app/pages/problemer-med-varmepumpe.vue?macro=true";
import { default as indexqLWzBFC1sIMeta } from "/vercel/path0/app/pages/shop/[slug]/index.vue?macro=true";
import { default as checkoutX3mww7rEv9Meta } from "/vercel/path0/app/pages/shop/checkout.vue?macro=true";
import { default as indexUcC2yXO8IbMeta } from "/vercel/path0/app/pages/shop/index.vue?macro=true";
import { default as solcellers6VOFV816QMeta } from "/vercel/path0/app/pages/solceller.vue?macro=true";
import { default as undgaa_45stoej_45fra_45varmepumpen8iRgD3DRc3Meta } from "/vercel/path0/app/pages/undgaa-stoej-fra-varmepumpen.vue?macro=true";
import { default as _91id_93M5wiBw7KIUMeta } from "/vercel/path0/app/pages/varmeplaner/[id].vue?macro=true";
import { default as indexTyaEzoAwnqMeta } from "/vercel/path0/app/pages/varmeplaner/index.vue?macro=true";
import { default as _91slug_93Yyyz4SdPY1Meta } from "/vercel/path0/app/pages/varmepumpe/[slug].vue?macro=true";
import { default as indexI3UEoERQQXMeta } from "/vercel/path0/app/pages/varmepumpe/index.vue?macro=true";
import { default as _91_46_46_46slug_93Rk0wKySkb2Meta } from "/vercel/path0/app/pages/viden/[...slug].vue?macro=true";
import { default as virker_45radiatoren_45ikkeHCBfxAxTt7Meta } from "/vercel/path0/app/pages/virker-radiatoren-ikke.vue?macro=true";
export default [
  {
    name: "amalo-grid",
    path: "/amalo-grid",
    component: () => import("/vercel/path0/app/pages/amalo-grid/index.vue")
  },
  {
    name: "amalo-grid-servicebesog",
    path: "/amalo-grid/servicebesog",
    component: () => import("/vercel/path0/app/pages/amalo-grid/servicebesog/index.vue")
  },
  {
    name: "bliv-en-del-af-amalo",
    path: "/bliv-en-del-af-amalo",
    component: () => import("/vercel/path0/app/pages/bliv-en-del-af-amalo.vue")
  },
  {
    name: "boligforeninger",
    path: "/boligforeninger",
    component: () => import("/vercel/path0/app/pages/boligforeninger.vue")
  },
  {
    name: "elvandvarmer",
    path: "/elvandvarmer",
    component: () => import("/vercel/path0/app/pages/elvandvarmer/index.vue")
  },
  {
    name: "er-du-amalos-nye-kunderaadgiver",
    path: "/er-du-amalos-nye-kunderaadgiver",
    component: () => import("/vercel/path0/app/pages/er-du-amalos-nye-kunderaadgiver.vue")
  },
  {
    name: "erhverv",
    path: "/erhverv",
    component: () => import("/vercel/path0/app/pages/erhverv.vue")
  },
  {
    name: "faa-et-gratis-tilbud-indenfor-24-timer",
    path: "/faa-et-gratis-tilbud-indenfor-24-timer",
    component: () => import("/vercel/path0/app/pages/faa-et-gratis-tilbud-indenfor-24-timer.vue")
  },
  {
    name: "garanti-service",
    path: "/garanti-service",
    component: () => import("/vercel/path0/app/pages/garanti-service.vue")
  },
  {
    name: "handelsbetingelser",
    path: "/handelsbetingelser",
    component: () => import("/vercel/path0/app/pages/handelsbetingelser.vue")
  },
  {
    name: "hvad-er-prisen-luft-til-vand-varmepumpe",
    path: "/hvad-er-prisen-luft-til-vand-varmepumpe",
    component: () => import("/vercel/path0/app/pages/hvad-er-prisen-luft-til-vand-varmepumpe.vue")
  },
  {
    name: "hvad-er-prisen-solceller",
    path: "/hvad-er-prisen-solceller",
    component: () => import("/vercel/path0/app/pages/hvad-er-prisen-solceller.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/app/pages/index.vue")
  },
  {
    name: "kan-din-varmepumpe-kole-boligen-ned",
    path: "/kan-din-varmepumpe-kole-boligen-ned",
    component: () => import("/vercel/path0/app/pages/kan-din-varmepumpe-kole-boligen-ned.vue")
  },
  {
    name: "kombinere-varmepumpe-solceller",
    path: "/kombinere-varmepumpe-solceller",
    component: () => import("/vercel/path0/app/pages/kombinere-varmepumpe-solceller.vue")
  },
  {
    name: "kondens-fra-varmepumpen",
    path: "/kondens-fra-varmepumpen",
    component: () => import("/vercel/path0/app/pages/kondens-fra-varmepumpen.vue")
  },
  {
    name: "luft-til-vand-varmepumpe-pris-montering",
    path: "/luft-til-vand-varmepumpe-pris-montering",
    component: () => import("/vercel/path0/app/pages/luft-til-vand-varmepumpe-pris-montering.vue")
  },
  {
    name: "luft-til-vand-varmepumpe",
    path: "/luft-til-vand-varmepumpe",
    component: () => import("/vercel/path0/app/pages/luft-til-vand-varmepumpe/index.vue")
  },
  {
    name: "luft-til-vand-varmepumpe-panasonic-varmepumpe",
    path: "/luft-til-vand-varmepumpe/panasonic-varmepumpe",
    component: () => import("/vercel/path0/app/pages/luft-til-vand-varmepumpe/panasonic-varmepumpe.vue")
  },
  {
    name: "minimer-stoej-fra-varmepumpen",
    path: "/minimer-stoej-fra-varmepumpen",
    component: () => import("/vercel/path0/app/pages/minimer-stoej-fra-varmepumpen.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/vercel/path0/app/pages/news/[slug].vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/vercel/path0/app/pages/news/index.vue")
  },
  {
    name: "news-page-page",
    path: "/news/page/:page()",
    component: () => import("/vercel/path0/app/pages/news/page/[page].vue")
  },
  {
    name: "om-amalo",
    path: "/om-amalo",
    component: () => import("/vercel/path0/app/pages/om-amalo.vue")
  },
  {
    name: "overslag-solceller-address",
    path: "/overslag-solceller/:address()",
    component: () => import("/vercel/path0/app/pages/overslag-solceller/[address].vue")
  },
  {
    name: "overslag-address",
    path: "/overslag/:address()",
    component: () => import("/vercel/path0/app/pages/overslag/[address].vue")
  },
  {
    name: "partner",
    path: "/partner",
    component: () => import("/vercel/path0/app/pages/partner.vue")
  },
  {
    name: "partnerskab-amalo-logbuy-solceller",
    path: "/partnerskab/amalo-logbuy-solceller",
    component: () => import("/vercel/path0/app/pages/partnerskab/amalo-logbuy-solceller.vue")
  },
  {
    name: "partnerskab-amalo-logbuy",
    path: "/partnerskab/amalo-logbuy",
    component: () => import("/vercel/path0/app/pages/partnerskab/amalo-logbuy.vue")
  },
  {
    name: "placering-af-varmepumpe",
    path: "/placering-af-varmepumpe",
    component: () => import("/vercel/path0/app/pages/placering-af-varmepumpe.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/vercel/path0/app/pages/privacy-policy.vue")
  },
  {
    name: "problemer-med-varmepumpe",
    path: "/problemer-med-varmepumpe",
    component: () => import("/vercel/path0/app/pages/problemer-med-varmepumpe.vue")
  },
  {
    name: "shop-slug",
    path: "/shop/:slug()",
    component: () => import("/vercel/path0/app/pages/shop/[slug]/index.vue")
  },
  {
    name: "shop-checkout",
    path: "/shop/checkout",
    component: () => import("/vercel/path0/app/pages/shop/checkout.vue")
  },
  {
    name: "shop",
    path: "/shop",
    component: () => import("/vercel/path0/app/pages/shop/index.vue")
  },
  {
    name: "solceller",
    path: "/solceller",
    component: () => import("/vercel/path0/app/pages/solceller.vue")
  },
  {
    name: "undgaa-stoej-fra-varmepumpen",
    path: "/undgaa-stoej-fra-varmepumpen",
    component: () => import("/vercel/path0/app/pages/undgaa-stoej-fra-varmepumpen.vue")
  },
  {
    name: "varmeplaner-id",
    path: "/varmeplaner/:id()",
    component: () => import("/vercel/path0/app/pages/varmeplaner/[id].vue")
  },
  {
    name: "varmeplaner",
    path: "/varmeplaner",
    component: () => import("/vercel/path0/app/pages/varmeplaner/index.vue")
  },
  {
    name: "varmepumpe-slug",
    path: "/varmepumpe/:slug()",
    component: () => import("/vercel/path0/app/pages/varmepumpe/[slug].vue")
  },
  {
    name: "varmepumpe",
    path: "/varmepumpe",
    component: () => import("/vercel/path0/app/pages/varmepumpe/index.vue")
  },
  {
    name: "viden-slug",
    path: "/viden/:slug(.*)*",
    component: () => import("/vercel/path0/app/pages/viden/[...slug].vue")
  },
  {
    name: "virker-radiatoren-ikke",
    path: "/virker-radiatoren-ikke",
    component: () => import("/vercel/path0/app/pages/virker-radiatoren-ikke.vue")
  }
]